import React from "react";
import discover from "../../assets/img/discover.png";
import Title from "../common/Title";
import Para from "../common/Para";
import CustomButton from "../common/PrimaryBtn";

const Discover = () => {
  return (
    <div>
      <div className="container sm:px-5 px-4 mx-auto 2xl:max-w-[1240px] relative sm:pt-20 pt-16">
        <div className="grid md:grid-cols-2 items-center xl:gap-10 gap-5">
          <div>
            <img className="w-full" src={discover} alt="discover" />
          </div>
          <div>
            <Title
              text="Discover River Cruising, Redefined"
              myClass="sm:mb-5 mb-4 mt-3 md:mt-0"
            />
            <Para
              myClass="sm:mb-7 mb-5"
              text="Lorem ipsum dolor sit amet consectetur. Elementum nunc duis turpis faucibus vulputate at morbi. Lobortis sociis fermentum nunc volutpat nibh pellentesque imperdiet facilisis. Vulputate proin sit tellus molestie leo enim. Tempus egestas auctor praesent non. Lorem ipsum dolor sit amet consectetur. Elementum nunc duis turpis faucibus vulputate at morbi. Lobortis sociis fermentum nunc volutpat nibh pellentesque imperdiet facilisis. Vulputate proin sit tellus molestie leo enim. Tempus egestas auctor praesent non. Lorem ipsum dolor sit amet consectetur. Elementum nunc duis turpis faucibus vulputate at morbi. Lobortis sociis fermentum nunc volutpat nibh pellentesque imperdiet facilisis. Vulputate proin sit tellus molestie leo enim. Tempus egestas auctor praesent non."
            />
            <CustomButton text="Learn More" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Discover;
